export default __webpack_public_path__ + "static/media/hht2_direction_songtime_02.f4bce816.jpg";